export default __webpack_public_path__ + "static/media/white_plus-small_icon.ecdf9639.svg";